<div class="dialog-header" mat-dialog-title>
    <span>Verplaatsen naar datum</span>
    <button class="close-button" (click)="onCancel()" mat-icon-button>
        <mat-icon fontSet="fa" fontIcon="fa-times"></mat-icon>
    </button>
</div>

<div class="dialog-content" mat-dialog-content>
    <div class="date-display-section">
        <div class="date-block">
            <div class="label">Van:</div>
            <div class="date-text">{{ originalDateFormatted }}</div>
        </div>

        <div class="arrow-divider">
            <mat-icon>arrow_forward</mat-icon>
        </div>

        <div class="date-block">
            <div class="label">Naar:</div>
            <div class="date-text" [class.selected]="selectedDate">
                {{ newDateFormatted || '(kies een datum)' }}
            </div>
        </div>
    </div>

    <mat-form-field class="date-picker-field" appearance="outline">
        <mat-label>Selecteer nieuwe datum</mat-label>
        <input [formControl]="dateControl" [matDatepicker]="picker" matInput readonly />
        <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    @if (daysDifference !== 0) {
        <div class="difference-info">
            <mat-icon>info</mat-icon>
            <span>
                @if (daysDifference > 0) {
                    Planningen worden {{ daysDifference }} dag{{ daysDifference === 1 ? '' : 'en' }} naar voren
                    verschoven
                } @else {
                    Planningen worden {{ Math.abs(daysDifference) }} dag{{ Math.abs(daysDifference) === 1 ? '' : 'en' }}
                    naar achter verschoven
                }
            </span>
        </div>
    }

    <div class="warning-info">
        <mat-icon>warning</mat-icon>
        <span>Alle planningen van {{ data.executor.name }} op {{ data.project.name }} worden verplaatst.</span>
    </div>
</div>

<div class="d-flex justify-content-end action-buttons" mat-dialog-actions>
    <button class="cancel-button" (click)="onCancel()" mat-button>Annuleren</button>
    <button
        class="confirm-button"
        [disabled]="!selectedDate || daysDifference === 0"
        (click)="onConfirm()"
        mat-raised-button
        color="primary">
        Verplaatsen
    </button>
</div>
